import type { PluginManifest, PluginToolbarButton, PluginToolbarSection } from './types';

const registered: PluginManifest[] = [];

export function registerPlugin(manifest: PluginManifest): void {
  if (registered.find((p) => p.id === manifest.id)) {
    console.warn(`[plugins] duplicate registration: ${manifest.id}`);
    return;
  }
  registered.push(manifest);
}

/**
 * Licence gate — currently stubbed to always-on. When the backend gains
 * an entitlements list, this becomes:
 *   const ents = useAuthStore.getState().entitlements ?? [];
 *   return ents.includes(`plugin.${pluginId}`);
 */
function isPluginEnabled(_pluginId: string): boolean {
  return true;
}

export function getEnabledPlugins(): PluginManifest[] {
  return registered.filter((p) => isPluginEnabled(p.id));
}

export function getToolbarButtons(section: PluginToolbarSection): PluginToolbarButton[] {
  const out: PluginToolbarButton[] = [];
  for (const p of getEnabledPlugins()) {
    if (!p.toolbarButtons) continue;
    for (const b of p.toolbarButtons) {
      if (b.section === section) out.push(b);
    }
  }
  return out;
}
